(function () {
  function openModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // Enable required only while modal is open (avoids browser "not focusable" errors)
    el.querySelectorAll('input[data-aur-required]').forEach(function (input) {
      input.required = true;
    });
    var first = el.querySelector('input, button');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }
  function closeModals() {
    document.querySelectorAll('.aur-modal').forEach(function (m) {
      m.querySelectorAll('input[data-aur-required]').forEach(function (input) {
        input.required = false;
      });
      m.hidden = true;
    });
    document.documentElement.style.overflow = '';
  }
  document.querySelectorAll('[data-aur-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-aur-open');
      if (target === 'sizechart') openModal('AurSizeChart');
      if (target === 'findsize') openModal('AurFindSize');
    });
  });
  document.querySelectorAll('[data-aur-close]').forEach(function (el) {
    el.addEventListener('click', closeModals);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModals();
  });

  var form = document.getElementById('AurFindSizeForm');
  var result = document.getElementById('AurFindSizeResult');
  if (form && result) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var height = parseFloat(form.height.value);
      var weight = parseFloat(form.weight.value);
      if (!height || !weight) return;
      var bmi = weight / Math.pow(height / 100, 2);
      var size = 'M';
      if (bmi < 18.5) size = height < 160 ? 'XS' : 'S';
      else if (bmi < 22) size = height < 165 ? 'S' : 'M';
      else if (bmi < 25) size = height < 170 ? 'M' : 'L';
      else if (bmi < 28) size = height < 175 ? 'L' : 'XL';
      else size = 'XXL';
      result.hidden = false;
      result.innerHTML =
        'Önerilen beden: <strong>' +
        size +
        '</strong><br><span style="font-size:1.2rem;color:#726a61;">Boy ' +
        height +
        ' cm · Kilo ' +
        weight +
        ' kg</span>';
    });
  }
})();
